import React, { useEffect, useState } from "react";
import AdminDashboard from "./components/AdminDashboard";
import Home from "./components/Home";
import AuthModal from "./components/landing/AuthModal";
import LandingPage from "./components/landing/LandingPage";
import { authService } from "./services/authService";

function App() {
  const [authState, setAuthState] = useState("login");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const loggedIn = authService.isLoggedIn();
    setIsLoggedIn(loggedIn);
    setCurrentUser(authService.getUser());
  }, []);

  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 300);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLoginSuccess = (user) => {
    setIsLoggedIn(true);
    setCurrentUser(user || authService.getUser());
    setShowAuthModal(false);
  };

  const handleSignupSuccess = (user) => {
    setIsLoggedIn(true);
    setCurrentUser(user || authService.getUser());
    setShowAuthModal(false);
  };

  const handleLogout = () => {
    authService.logout();
    setIsLoggedIn(false);
    setCurrentUser(null);
    setShowAuthModal(false);
    setAuthState("login");
  };

  if (isLoggedIn) {
    if (currentUser?.role === "ADMIN") {
      return <AdminDashboard onLogout={handleLogout} />;
    }

    return <Home onLogout={handleLogout} />;
  }

  return (
    <>
      {showAuthModal && (
        <AuthModal
          authState={authState}
          onClose={() => setShowAuthModal(false)}
          onLoginSuccess={handleLoginSuccess}
          onSignupSuccess={handleSignupSuccess}
          onSwitchToLogin={() => setAuthState("login")}
          onSwitchToSignup={() => setAuthState("signup")}
        />
      )}
      <LandingPage
        menuOpen={menuOpen}
        showScroll={showScroll}
        onToggleMenu={() => setMenuOpen((current) => !current)}
        onShowAuthModal={() => setShowAuthModal(true)}
        onCloseMenu={() => setMenuOpen(false)}
      />
    </>
  );
}

export default App;
